<template>
  <div>
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <h3>{{ info_notificacion.titulo }}</h3>
        </div>
        <div class="col-8 text-center mt-3">
          <h5>{{ info_notificacion.contenido }}</h5>
        </div>
        <div
          v-if="
            info_notificacion.meeting != null && info_notificacion.meeting != ''
          "
          class="col-12 text-center my-3"
        >
          <a
            style="background-color: blue;color:white"
            target="_blank"
            :href="info_notificacion.meeting"
            class="btn"
          >
            <img style="max-height:30px;" src="static/img/meet.png" alt="" />
            Entrar a la reunión
          </a>
        </div>
        <div class="col-12 text-center mt-3">
          <h6>Fecha de Notificación: "{{ info_notificacion.fecha }}"</h6>
        </div>
      </div>
      <div
        class="row justify-content-center mt-5"
        v-if="info_notificacion.idsolicitud != null"
      >
        <div
          class="col-12 text-center "
          v-if="info_notificacion.solicitud.estatus == 1"
        >
          <button class="btn btn-success" v-on:click="Aceptar_Solicitud">
            Aceptar
          </button>
          <button class="btn btn-danger ml-1" v-on:click="Rechazar_Solicitud">
            Rechazar
          </button>
        </div>
        <div
          class="col-12 text-center "
          v-if="info_notificacion.solicitud.estatus == 2"
        >
          <h5 class="text-danger"><b>Rechazada</b></h5>
        </div>
        <div
          class="col-12 text-center "
          v-if="info_notificacion.solicitud.estatus == 3"
        >
          <h5 class="text-success"><b>Aceptada</b></h5>
        </div>
      </div>
      <div
        class="row justify-content-around"
        v-else-if="solicitud_curso != null"
      >
        <div class="col-auto">
          <button class="btn btn-success" v-on:click="Aceptar_Solicitud_Curso" v-if="solicitud_curso.estado == 'Pendiente'">
            Aceptar
          </button>
        </div>
        <div class="col-auto">
          <button class="btn btn-danger ml-1" v-on:click="Rechazar_Solicitud_Curso" v-if="solicitud_curso.estado == 'Pendiente'">
            Rechazar
          </button>
        </div>
      </div>
      <div
        class="row justify-content-center mt-5"
        v-if="info_notificacion.contenido == 'Capacitaciones próximas a vencer'"
      >
        <div class="col-12 text-center">
          <button
            class="btn btn-success"
            v-on:click="Capacitaciones_Proximas_Vencer"
          >
            Ver Reporte
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      loading: "d-none",
      result: "d-none",
      info_notificacion: {
        idnotificacion: null,
        titulo: null,
        contenido: null,
        web: null,
        mobile: null,
        meeting: null,
        fecha_hora: null,
        origen: null,
        destino: null,
        estatus: null,
        solicitud: {
          idsolicitud: null,
          cve_empleado: null,
          nombre_empleado: null,
          cve_supervisor: null,
          nombre_supervisor: null,
          cve_analista: null,
          nombre_analista: null,
          cve_instructor: null,
          nombre_instructor: null,
          cve_curso: null,
          nombre_curso: null,
          fecha_curso: null,
          horario_curso: null,
          nombre_sala: null,
          link_confirmar: null,
          link_rechazar: null,
          subject: null,
          estatus: null
        }
      },
      solicitud_curso:null
    };
  },
  methods: {
    Capacitaciones_Proximas_Vencer() {
      this.Cerrar_Modal();
      this.$router.push({ name: "Capacitaciones_Proximas_Vencer" });
    },
    Aceptar_Solicitud() {
      this.Cargando();
      this.$http
        .post(
          "solicitudes/aceptar/" + this.info_notificacion.solicitud.idsolicitud,
          { cve_coordinador: menu.usuario.cve_coordinador }
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.Listo();
          if (respuestaJson.resp == true) {
            this.Cerrar_Modal();
            this.Actualizar_Notificaciones();
            if (
              this.info_notificacion.titulo ==
              "Solicitud de Inscripción a Curso"
            ) {
              swal(
                "Excelente",
                "Ahora el analista del curso aceptará la solicitud",
                "success"
              );
            } else {
              swal(
                "Excelente",
                "La solicitud ha sido aceptada con éxito",
                "success"
              );
            }
          } else {
            swal("¡Ups!", respuestaJson.resp, "error");
          }
        })
        .catch(error => {
          this.Listo();
          swal("¡Ups!", "Problemas para aceptar la solicitud", "error");
        });
    },
    Rechazar_Solicitud() {
      this.Cargando();
      this.$http
        .post(
          "solicitudes/rechazar/" + this.info_notificacion.solicitud.idsolicitud
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.Listo();
          if (respuestaJson.resp == true) {
            this.Cerrar_Modal();
            this.Actualizar_Notificaciones();
            swal(
              "Excelente",
              "La solicitud ha sido rechazada con éxito",
              "success"
            );
          } else {
            swal("¡Ups!", respuestaJson.resp, "error");
          }
        })
        .catch(error => {
          this.Listo();
          swal("¡Ups!", "Problemas para rechazar la solicitud", "error");
        });
    },
    Aceptar_Solicitud_Curso(){
      this.$router.push({name:"Programar_Curso", params:{solicitud:this.solicitud_curso}})
      this.Cerrar_Modal();
    },
    Rechazar_Solicitud_Curso(){
      this.Cargando();
      let that = this;
      this.$http
        .post(
          "cursos/rechazarSolicitudCurso",{cve_solicitud:that.solicitud_curso.cve_solicitud}
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.Listo();
          if (respuestaJson.res == "Excelente") {
            this.Cerrar_Modal();
            this.Actualizar_Notificaciones();
            swal(
              "Excelente",
              "La solicitud ha sido rechazada con éxito",
              "success"
            );
            that.solicitud_curso.estado = "Rechazado"
          } else {
            swal("¡Ups!", "Problemas para rechazar la solicitud, si el error persiste contacta a tu proveedor de servicio", "error");
          }
        })
        .catch(error => {
          this.Listo();
          swal("¡Ups!", "Problemas para rechazar la solicitud", "error");
        });
    },
    Consultar() {
      let that = this;
      this.Cargando();
      this.$http
        .get("notificaciones/" + this.notificacion.idnotificacion)
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {

          if (respuestaJson.length > 0) {
            this.info_notificacion = respuestaJson[0];
            console.log(this.info_notificacion);
            try {
              const regex = /(\d*)( - )(Solicitud de nuevas fechas para el curso)/gm;
              if (this.info_notificacion.titulo.match(regex).length > 0) {
                this.solicitud_curso = {}
                this.solicitud_curso["cve_solicitud_curso"] = this.info_notificacion.titulo.split(
                  regex
                )[1];
                that.$http.get("cursos/getSolicitudCurso/"+this.solicitud_curso["cve_solicitud_curso"]).
                then((respuesta)=>{
                  return respuesta.json();
                }).then((respuestaJson)=>{
                  if(respuestaJson.res="Excelente"){
                    that.solicitud_curso = respuestaJson.solicitud
                    that.Listo()
                  } else {
                    toastr.error("Problemas para consultar la solicitud")
                  }
                })
              }
            } catch (error) {
              this.Listo();
            }
            this.Actualizar_Notificaciones();
          } else {
            this.Actualizar_Notificacion({ idnotificacion: null });
            this.Cerrar_Modal();
            swal(
              "¡Ups!",
              "La notificación ya no se encuentra disponible",
              "error"
            );
          }
        })
        .catch(error => {
          this.Actualizar_Notificacion({ idnotificacion: null });
          this.Listo();
          this.Cerrar_Modal();
          swal("¡Ups!", "Problemas para consultar la notificacion", "error");
        });
    },
    ConsultarSolicitudCurso() {},
    Cerrar_Modal() {
      $("#cerrar_modal_ver_notificacion").click();
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo() {
      var that = this;
      $(document).ready(function() {
        that.loading = "d-none";
        that.result = "";
      });
    },
    ...mapActions([
      "Ejecutar_Tabla",
      "Actualizar_Notificacion",
      "Actualizar_Notificaciones"
    ])
  },
  watch: {
    "notificacion.idnotificacion": function() {
      this.solicitud_curso = null;
      if (this.notificacion.idnotificacion != null) {
        this.Consultar();
      }
    }
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    notificacion() {
      return this.$store.getters.getNotificacion;
    }
  },
  mounted() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/AppLms/Notificaciones/Notificacion.vue